/** Contact form enquiry topics — used for routing links across the site */

export const CONTACT_TOPICS = [
  { value: '', label: 'Select the reason for your enquiry' },
  { value: 'general', label: 'General passenger enquiry' },
  { value: 'flights', label: 'Flight information & schedules' },
  { value: 'baggage', label: 'Baggage, lost & found' },
  { value: 'assistance', label: 'Special assistance (PRM / accessibility)' },
  { value: 'vip', label: 'VIP lounge & meet and greet' },
  { value: 'parking', label: 'Parking & ground transport' },
  { value: 'security', label: 'Security & prohibited items' },
  { value: 'immigration', label: 'Immigration, visa & customs' },
  { value: 'dining', label: 'Dining, shopping & terminal facilities' },
  { value: 'cargo', label: 'Cargo & freight' },
  { value: 'commercial', label: 'Commercial, retail & advertising' },
  { value: 'airlines', label: 'Airlines & aviation' },
  { value: 'careers', label: 'Careers & recruitment' },
  { value: 'events', label: 'Events & venue hire' },
  { value: 'feedback', label: 'Feedback or complaint' },
  { value: 'media', label: 'Media & press' },
  { value: 'privacy', label: 'Privacy & data protection' },
  { value: 'website', label: 'Website or technical issue' },
  { value: 'other', label: 'Other' },
];

export function isValidContactTopic(value) {
  return CONTACT_TOPICS.some((t) => t.value && t.value === value);
}

export function contactTopicLabel(value) {
  return CONTACT_TOPICS.find((t) => t.value === value)?.label || '';
}
